import { useContext, useReducer } from "react";
import "isomorphic-fetch";
import { useRouter } from "next/router";
import { authenticatedFetch } from "../../utils/authenticatedFetch.js";
import AppContext from "../appContext";
import DiscountContext from "./DiscountContext";
import discountReducer from "./discountReducer";
// import moment from "moment-timezone";
let shop2;
let shopOrigin4;
let origin = "";
const changeQueryStringToJSON = (search) => {
  let pairs = search.slice(1).split("&");
  var result = {};
  pairs.forEach(function (pair) {
    pair = pair.split("=");
    result[pair[0]] = decodeURIComponent(pair[1] || "");
  });
  return result;
};
if (typeof window !== "undefined") {
  let search = window.location.search;
  let searchObject = changeQueryStringToJSON(search);
  origin = window.location.origin;

  if (search != "") {
    shop2 = search.split("&");
    shopOrigin4 = searchObject?.shop;
  } else {
    shopOrigin4 = window?.location.host;
  }
}

let shop = shopOrigin4;

let _id;

let storeMeteaFieldIDVal = 0;
let productSyncStatus = "";


const DiscountState = (props) => {
  const router = useRouter();

  const initialState = {
    discountRules: [],
    singleDiscountRule: null,
    loading: true,
    saving: false,
    loadingDiscounts: false,
    message: "This is from context",
    toggleStatus: "",
    topbarAlertStatus: "  ",

    bulkRules: [],
    loadingBulk: true,
    loadingBulkTable: true,
    loadingDiscount: true,
    titlePrice: [],
    impactedVariants: { variants: [], impactedVariants: [] },
    BulkDiscountId: [],
    discountRulesPriceChange: [],
    ListBulkStartDate: [],
    listAllEndDate: [],
    listAllEndDate: [],
    ListDiscountStartDate: [],
    ListBulkEndDate: [],
    ListDiscountEndDate: [],
    countryCode: "",
    countryDate: "",
    countryTime: "",
    countryDateTime: null,
    countryCurrency: "",
    totalUpdatedProducts: "",
    totalUpdatedProductsReverting: "",
    variantCountArr: 0,
    analyticsCount: {},
    totalStoreProductsCount: 0,
    productsFetchingStatus: "",
    productsFetchingStatusCurrentCount: 0,
    productsFetchingStatusTotalCount: 0,
    priceLogFilterStatus: "",
    gettingFilterStatusFromRes: "",
    mulipleBulkPriceChangeStatus: "",
    toastStatus: "",

    discountRulesCreateSale: [],
    bulkDiscountList: [],
    allLogsList: [],
    ListCreateSaleStartDate: [],
    ListCreateSaleEndDate: [],
    salesClockData: [],
    bulkTableData: [],
    saleLogToEdit: {},
    variantsToReRunSaleOn: [],
    variantsToReRunSaleOnWithProducts: [],

    bulkDiscountToEdit: {},
    queueStatus: {},
    uploadedSKU: [],
    storeDataTimeCurrency: {},
    filterLazyLoading: false,
    logUnderObs: null,
    subscriptionStatus: false,
    totalAppliedRules: 0,
    hamburgerState: false,
    error: {
      type: false,
      message: "",
    },
  };

  const { host, jwtToken, shop1 } = useContext(AppContext);
  const [state, dispatch] = useReducer(discountReducer, initialState);

  const setSubscribtionStatus = (value) => {
    dispatch({ type: "SET_SUBSCRIPTION_STATUS", payload: value });
  };

  const setHamburgetState = (value) => {
    dispatch({ type: "SET_HAMBURGER_STATE", payload: value });
  };

  const setTotalAppliedRules = (value) => {
    dispatch({ type: "SET_TOTAL_APPLIED_RULES", payload: value });
  };

  const getSubscriptionStatus = async(callback = () => {}) => {
    authenticatedFetch({
      path: `/api/getSubscriptionStatus/${shop}?shop=${shop1}`,
      method: "GET",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getSubscription");
        }
      })
      .then((data) => {
        console.log("Subscription Data", data);
        const { subscription, totalAppliedRules, error } = data;
        if (error == true) {
          callback(error, data);
        } else {
          setSubscribtionStatus(subscription);
          setTotalAppliedRules(totalAppliedRules);
          callback(false, data);
        }
      })
      .catch((err) => {
        callback(true);
      });
  };

  const switchToPro = async (callback) => {
    authenticatedFetch({
      path: `/api/createSubscription/${shop}?shop=${shop1}`,
      method: "GET",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw new Error("Failed To Buy Pro Plan");
      })
      .then((data) => {
        const { subscription, totalAppliedRules, error, message } = data;
        if (error == true) {
          callback(error, data);
        } else {
          setSubscribtionStatus(subscription);
          authenticatedFetch({
            path: `/api/storeAppearance/${shop}?shop=${shop1}`,
            method: "get",
            host,
            jwtToken,
            shop1,
          })
            .then((res) => {
              if (res.ok) return res.json();
              else {
                throw new Error("Something went wrong pi/storeAppearance");
              }
            })
            .then(({ isAvailable, strikePrice }) => {
              //console.log("PPPPPPPP", subscription, strikePrice, strikePrice[0].design.subscription);
              strikePrice[0].design.subscription=subscription;
              BulkTableDesign(strikePrice[0]);
            })
          // setTotalAppliedRules(totalAppliedRules);
          callback(false, data);
        }
      })
      .catch((err) => {
        callback(true);
      });
  };

  const switchToFree = async (callback) => {
    authenticatedFetch({
      path: `/api/switchToFree/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw new Error("Failed To Buy Pro Plan1");
      })
      .then((data) => {
        const { subscription, totalAppliedRules, error, message } = data;
        if (error == true) {
          callback(error, data);
        } else {
          setSubscribtionStatus(subscription);
          authenticatedFetch({
            path: `/api/storeAppearance/${shop}?shop=${shop1}`,
            method: "get",
            host,
            jwtToken,
            shop1,
          })
            .then((res) => {
              if (res.ok) return res.json();
              else {
                throw new Error("Something went wrong pi/storeAppearance");
              }
            })
            .then(({ isAvailable, strikePrice }) => {
              //console.log("PPPPPPPP000", subscription, strikePrice, strikePrice[0].design.subscription);
              strikePrice[0].design.subscription=subscription;
              BulkTableDesign(strikePrice[0]);
            })
          callback(false, data);
        }
      })
      .catch((err) => {
        callback(true);
      });
  };

  const handleAPIError = (message, type = "error") => {
    // variant could be success, error, warning, info, or default
    dispatch({ type: "SET_API_ERROR", payload: { type, message } });
  };

  const setVariantsToReRunSaleOn = (
    variants,
    notImpactedVariantsWithProducts,
    isBulkChange,
    saleLogUnderObs
  ) => {
    dispatch({ type: `SET_VARIANTS_TO_RERUN_SALE_ON`, payload: variants });
    dispatch({
      type: `SET_VARIANTS_TO_RERUN_SALE_ON_WITH_PRODUCTS`,
      payload: notImpactedVariantsWithProducts,
    });
    dispatch({ type: "LOG_UNDER_OBSERVATION", payload: saleLogUnderObs });
    router.push(isBulkChange ? "/RerunBulkChange" : "/RerunSale");
  };

  const setSaleLogToEdit = (saleLogObj) => {
    dispatch({ type: `SET_SALE_LOG_TO_EDIT`, payload: saleLogObj });
    router.push("/EditSalesLog");
  };

  const setBulkDiscountToEdit = (bulkDiscountObject) => {
    dispatch({
      type: `SET_BULK_DISCOUNT_TO_EDIT`,
      payload: bulkDiscountObject,
    });
    router.push("/bulk-discount/edit");
  };

  const checkQueueStatus = () => {
    authenticatedFetch({
      path: `/api/checking_queue_status/${shop}?shop=${shop1}`,
      method: "GET",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        // console.log("Queye status", res);
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong checking_queue_status");
        }
      })
      .then((data) => {
        dispatch({ type: "SET_QUEUE_STATUS", payload: data });
      })
      .catch((error) => {});
  };
  //set loading for singleDiscount rule true
  const setLodingTrue = () => {
    dispatch({ type: `SET_LOADING_TRUE` });
  };

  //set loading for singleDiscount rule false
  const setLodingFalse = () => {
    dispatch({ type: `SET_LOADING_FALSE` });
  };

  //set loading for discountRules true
  const setLodingDiscountsTrue = () => {
    dispatch({ type: `SET_LOADING_DISCOUNTS_TRUE` });
  };

  //set loading for bulkRules true
  const setLodingBulkTrue = () => {
    dispatch({ type: `SET_LOADING_BULK_TRUE` });
  };

  const setLodingBulkTableTrue = () => {
    dispatch({ type: `SET_LOADING_BULK_TABLE_TRUE` });
  };

  //set loading for bulkRules true
  const setLodingDiscountTrue = () => {
    dispatch({ type: `SET_LOADING_DISCOUNT_TRUE` });
  };

  //set loading for discountRules false
  const setLodingDiscountsFalse = () => {
    dispatch({ type: `SET_LOADING_DISCOUNTS_FALSE` });
  };

  //set loading for BulkRules false
  const setLodingBulkFalse = () => {
    dispatch({ type: `SET_LOADING_BULK_FALSE` });
  };

  const setLodingBulkTableFalse = () => {
    dispatch({ type: `SET_LOADING_BULK_TABLE_FALSE` });
  };

  //set loading for BulkRules false
  const setLodingDiscountFalse = () => {
    dispatch({ type: `SET_LOADING_DISCOUNT_FALSE` });
  };

  //set saving true
  const setSavingTrue = () => {
    dispatch({ type: `SET_SAVING_TRUE` });
  };

  //set saving false
  const setSavingFalse = () => {
    dispatch({ type: `SET_SAVING_FALSE` });
  };

  // Create a Storewide Sale Rule
  const createStorewideSale = async (rulesObj) => {
    rulesObj.store = shop;
    rulesObj.createdBy = _id;

    authenticatedFetch({
      path: `/api/storewideSale?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify(rulesObj),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong storewideSale");
        }
      })
      .then((res) => {
        dispatch({ type: `CREATE_STOREWIDE_SALE`, payload: rulesObj });
      })
      .catch((error) => {});
  };

  const reRunSale = async (id) => {
    authenticatedFetch({
      path: `/api/storewideSale_rerun_sale?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ data: { id: id, store: shop } }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong storewideSale_rerun_sale");
        }
      })
      .then((res) => {})
      .catch((error) => {});
  };

  const checkSaleLogEndDates = async (callback) => {
    //api/checkSaleLogEndDates/:shop
    authenticatedFetch({
      path: `/api/checkSaleLogEndDates/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong checkSaleLogEndDates");
        }
      })
      .then(({ saleWithEndDateExists }) => {
        callback(saleWithEndDateExists);
      })
      .catch((error) => {
        console.error(error);
        throw new Error("Check Sale Log EndDates Error",error);
      });
  };

  // List Discount Rules
  const listDiscountRules = () => {
    setLodingDiscountsTrue();

    //send store/shop as query
    authenticatedFetch({
      path: `/api/discount?store=${shop}`,
      method: "GET",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong discount");
        }
      })
      .then(({ discounts }) => {
        dispatch({ type: `LIST_DISCOUNT_RULES`, payload: discounts });
      })
      .then(() => {
        setLodingDiscountsFalse();
      })
      .catch((error) => {});
  };

  // Get a single Discount Rule
  /*
    discount_id is the id of the discount obj from discount collection
    type_id is the id of the type of discount it has (storewide sale id, buld order id, etc)
    type is the number indicating the type of the discount
  */
  const getSingleDiscountRule = (discount_id, type_id, type) => {
    setLodingTrue();
    //check which type of discount it is
    /*
      0 = Storewide Sale
      1 = Bulk Order
      etc...
    */
    //if type is storewide Sale
    if (type === "0") {
      authenticatedFetch({
        path: `/api/storewideSale/${type_id}?shop=${shop1}`,
        method: "get",
        host,
        jwtToken,
        shop1,
      })
        .then((res) => {
          if (res.ok) return res.json();
          else {
            throw new Error("Something went wrong storewideSale");
          }
        })
        .then(({ storewideSale, discount }) => {
          dispatch({
            type: `GET_SINGLE_DISCOUNT_RULE`,
            payload: { storewideSale, discount },
          });
        })
        .then(() => {
          setLodingFalse();
        })
        .catch((error) => {});
    }
  };

  //delete a Discount Rule
  const deleteDiscountRule = (discount_id, type_id, type) => {
    //check which type of discount it is
    /*
      0 = Storewide Sale
      1 = Bulk Order
      etc...
    */
    //if type is storewide Sale
    if (type === 0) {
      authenticatedFetch({
        path: `/api/storewideSale/${discount_id}?shop=${shop1}`,
        method: "delete",
        host,
        jwtToken,
        shop1,
      })
        .then((res) => {
          if (res.ok) return res.json();
          else {
            throw new Error("Something went wrong storewideSa");
          }
        })
        .then(({ msg, storewideSale, discount }) => {
          dispatch({ type: `DELETE_DISCOUNT`, payload: discount_id });
        })
        .then(() => {
          listDiscountRules();
        })
        .catch((error) => {});
    }
  };

  //clear single discount rule
  const clearSingleDiscountRule = () => {
    dispatch({
      type: `CLEAR_SINGLE_DISCOUNT`,
    });
  };

  //update a Discount Rule
  const updateDiscountRule = (type_id, type, discountObj) => {
    setSavingTrue();
    //check which type of discount it is
    /*
      0 = Storewide Sale
      1 = Bulk Order
      etc...
    */
    //if type is storewide Sale
    if (type === 0) {
      authenticatedFetch({
        path: `/api/storewideSale/${type_id}?shop=${shop1}`,
        method: "PUT",
        body: JSON.stringify(discountObj),
        host,
        jwtToken,
        shop1,
      })
        .then((res) => {
          if (res.ok) return res.json();
          else {
            throw new Error("Something went wrong storewid");
          }
        })
        .then(({ msg, storewideSale, discount }) => {})
        .then(() => {
          setSavingFalse();
        })
        .then(() => {})
        .catch((error) => {
          setSavingFalse();
        });
    }
  };

  //toggle isActive of a discount
  const toggleIsActive = (_id, index) => {
    dispatch({ type: `TOGGLE_IS_ACTIVE`, payload: index });

    authenticatedFetch({
      path: `/api/discount/toggleIsActive/${_id}?shop=${shop1}`,
      method: "put",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong toggleIsActive");
        }
      })
      .then((res) => {
        dispatch({ type: `TOGGLE_STATUS`, payload: res.msg });
      })
      .catch((error) => {});
  };

  // To test context api
  const changeMessage = (newMessage) => {
    dispatch({ type: `CHANGE_MESSAGE`, payload: newMessage });
  };

  /////////////////// BULK PRICE CHANGE/////////////////

  const clearProductFilteringList = () => {
    dispatch({ type: "BulkDiscount", payload: [] });
  };

  const createBulkOperation = async (data, recordsPerPage = 100) => {
    data.forEach((filter) => {
      if (filter.search_attribute == "productTag")
        filter.search_key = filter.search_key.toString().toLowerCase();
    });
    const resetValues = () => {
      dispatch({ type: "BulkDiscount", payload: [] });
      dispatch({ type: "BulkDiscountId", payload: [] });
      dispatch({ type: "VARIANT_COUNT", payload: 0 });

      dispatch({ type: "PRICE_LOG_FILTER_STATUS", payload: "success" });
      dispatch({ type: "PRICE_LOG_FILTER_STATUS_RESET", payload: "" });
    };
    const handleResponse = async (res, currentRequestNumber) => {
      if (res.status == "success") {
        const finArr = [];
        let variantCount = 0;
        for (let i = 0; i < res.results.length; i++) {
          for (let j = 0; j < res.results[i].variants.length; j++) {
            const variantId_3 =
              res.results[i].variants[j].variant_id.toString();
            const variantId_2 = variantId_3.split("/");
            const variantId = variantId_2[4];

            const price = res.results[i].variants[j].variant_price.toString();

            let comparePrice = res.results[i].variants[j].variant_com_price;

            if (!comparePrice) {
              comparePrice = "null";
            }
            finArr.push(variantId.concat("$", price.concat("$", comparePrice)));
            variantCount++;
          }
        }

        currentRequestNumber === 1 &&
          checkBulkPriceChangeRequestImpectedVariants(finArr);

        return {
          BulkDiscount: res.results,
          BulkDiscountId: finArr,
          totalVariantCount: res.totalVariantCount,
        };
      } else {
        return {
          BulkDiscount: [],
          BulkDiscountId: [],
          totalVariantCount: res.totalVariantCount,
          notFound: true,
        };
      }
    };

    let currentPage = 0;
    let totalRequestToBeMade;
    let continue_ = true;
    var BulkDiscount_ = [];
    var BulkDiscountId_ = [];
    resetValues();
    // SET_FILTER_LAZY_LOADING
    dispatch({ type: "SET_FILTER_LAZY_LOADING", payload: true });
    while (continue_) {
      try {
        let response = await authenticatedFetch({
          path: `/api/createBulkOperation?shop=${shop1}`,
          method: "POST",
          body: JSON.stringify({ data, shop, currentPage, recordsPerPage }),
          host,
          jwtToken,
          shop1,
        });
        response = await response.json();
        if (currentPage == 0) {
          totalRequestToBeMade = Math.ceil(
            response.totalRecords / recordsPerPage
          );
        }

        currentPage += 1;

        const data_ = await handleResponse(response, currentPage);
        if (!data_.notFound) {
          BulkDiscount_ = [...BulkDiscount_, ...data_.BulkDiscount];
          BulkDiscountId_ = [...BulkDiscountId_, ...data_.BulkDiscountId];
          dispatch({ type: "BulkDiscount", payload: [...BulkDiscount_] });
          dispatch({ type: "BulkDiscountId", payload: [...BulkDiscountId_] });
          dispatch({ type: "VARIANT_COUNT", payload: data_.totalVariantCount });
          dispatch({
            type: "PRICE_LOG_FILTER_STATUS",
            payload: response.status,
          });
          dispatch({ type: "PRICE_LOG_FILTER_STATUS_RESET", payload: "" });
          if (
            currentPage == totalRequestToBeMade ||
            totalRequestToBeMade === 0
          ) {
            dispatch({ type: "SET_FILTER_LAZY_LOADING", payload: false });
            break;
          }
        } else {
          dispatch({ type: "BulkDiscount", payload: [] });
          dispatch({ type: "BulkDiscountId", payload: [] });
          dispatch({ type: "VARIANT_COUNT", payload: 0 });
          dispatch({ type: "PRICE_LOG_FILTER_STATUS", payload: "success" });
          dispatch({ type: "PRICE_LOG_FILTER_STATUS_RESET", payload: "" });
          dispatch({ type: "SET_FILTER_LAZY_LOADING", payload: false });
          break;
        }
      } catch (err) {
        continue_ = false;
        resetValues();
      }
    }
  };

  const checkBulkPriceChangeRequestImpectedVariants = (data) => {
    authenticatedFetch({
      path: `/api/checkBulkPriceChangeRequestImpectedVariants?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ data, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong checkBulkPriceChangeRequestImpectedVariant");
        }
      })
      .then((res) => {
        dispatch({
          type: `MULIPLE_BULK_PRICE_CHANGE_STATUS`,
          payload: res.status,
        });
      })
      .catch((error) => {});
  };

  const setVariantCount = (value) => {
    dispatch({ type: "VARIANT_COUNT", payload: value });
  };

  const saveBulkPriceChangeRequest = async (data, callback) => {
    data.store = shop;
    data.createdBy = _id;
    let payload = {
      urls: {
        mainRoute: `/api/saveBulkPriceChangeRequest?shop=${shop}`,
        bufferRoute: `/api/bufferData?shop=${shop}`,
      },
      keysToBuffer: ["productId", "excludedArray"],
      data,
      type: "BULK",
      method: "POST",
      shop,
    };
    if (data.showManualProductsContainer && !data.file_status) {
      if (data.excludedArray.length < data.includedVariantsData.length) {
        delete data.productId;
        delete data.includedVariantsData;
        data.includedStatus = false;
        if (data.excludedArray.length > payload.lengthPerRequest) {
          data.bufferStatus = true;
        }
      } else {
        data.productId = JSON.parse(JSON.stringify(data.includedVariantsData));
        data.includedStatus = true;
        delete data.excludedArray;
        delete data.includedVariantsData;
        if (data.productId.length > payload.lengthPerRequest) {
          data.bufferStatus = true;
        }
      }
    }
    await bufferRequest(payload, callback);
  };

  const editBulkPriceChangeRequest = async (data) => {
    data.store = shop;
    data.createdBy = _id;
    authenticatedFetch({
      path: `/api/updateBulkPriceChangeLog?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ data, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong updateBulkPriceChangeLog");
        }
      })
      .then((res) => {
        dispatch({ type: `CREATE_PRICE_CHANGE`, payload: data });
      })
      .catch((error) => {});
  };

  const getBulkPriceChangeLogFirstTime = () => {
    setLodingBulkTrue();
    authenticatedFetch({
      path: `/api/getBulkPriceChangeLogs/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getBulkPriceChangeLogs");
        }
      })
      .then((data) => {
        handleBulkPriceChangeLogResult(data);
        setLodingBulkFalse();
      })
      .catch((error) => {});
  };

  const handleBulkPriceChangeLogResult = ({
    bulk_price_responce,
    bulk_price,
    start_date,
    end_date,
  }) => {
    if (bulk_price_responce == 0) {
      dispatch({
        type: `LIST_BULK_RULES`,
        payload: [],
      });
      return;
    }

    dispatch({
      type: `LIST_BULK_RULES`,
      payload: bulk_price_responce,
    });
    dispatch({ type: `LIST_BULK_START_DATE`, payload: start_date });
    dispatch({ type: `LIST_BULK_END_DATE`, payload: end_date });
  };

  const getBulkPriceChangeLog = () => {
    authenticatedFetch({
      path: `/api/getBulkPriceChangeLogs/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getBulkPriceChangeLog");
        }
      })
      .then(handleBulkPriceChangeLogResult)
      .catch((error) => {});
  };

  const cancelBulkPriceChangeLogs = async (metaFieldId) => {
    setLodingBulkTrue();

    authenticatedFetch({
      path: `/api/cancelBulkPriceChangeLogs/${metaFieldId}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong cancelBulkPriceChange");
        }
      })
      .then((res) => {
        getBulkPriceChangeLog();
        setTimeout(() => {
          setLodingBulkFalse();
        }, 1000);
      })
      .catch((error) => {});
  };

  const getUpdatedProducts = (caller = "initial") => {
    authenticatedFetch({
      path: `/api/getUpdatedProductsCount/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getUpdatedProducts");
        }
      })
      .then(({ storeMeteaFieldID }) => {
        if (caller == "initial") {
          dispatch({ type: `UPDATED_PRODCUTS`, payload: storeMeteaFieldID });
        } else if (
          caller == "iteration" &&
          storeMeteaFieldID != storeMeteaFieldIDVal
        ) {
          dispatch({ type: `UPDATED_PRODCUTS`, payload: storeMeteaFieldID });
          storeMeteaFieldIDVal = storeMeteaFieldID;
          setTimeout(() => {
            getSaleLogs("force");
            getDiscountLogs("force");
          }, 5000);
        } else {
        }
      })
      .catch((error) => {});
  };

  const productImpactedModalList = (id) => {};

  /////////////////// CREATE A SALE /////////////////
  const createStorewideBulkOperation = async (data) => {
    authenticatedFetch({
      path: `/api/createStorewideBulkOperation?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ data, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong createStorewideBulk");
        }
      })
      .then((res) => {
        if (res.status == "success") {
          const finArr = [];
          let variantCount = 0;
          for (let i = 0; i < res.allproducts.length; i++) {
            for (let j = 0; j < res.allproducts[i].variants.length; j++) {
              const variantId_3 =
                res.allproducts[i].variants[j].variant_id.toString();
              const variantId_2 = variantId_3.split("/");
              const variantId = variantId_2[4];

              const price =
                res.allproducts[i].variants[j].variant_price.toString();

              let comparePrice =
                res.allproducts[i].variants[j].variant_com_price;

              if (!comparePrice) {
                comparePrice = "null";
              }
              finArr.push(
                variantId.concat("$", price.concat("$", comparePrice))
              );
              variantCount++;
            }
          }

          dispatch({ type: "BulkDiscount", payload: res.allproducts });
          dispatch({ type: "BulkDiscountId", payload: finArr });
          dispatch({ type: "VARIANT_COUNT", payload: variantCount });

          dispatch({ type: "PRICE_LOG_FILTER_STATUS", payload: res.status });
          dispatch({ type: "PRICE_LOG_FILTER_STATUS_RESET", payload: "" });
        } else {
          dispatch({ type: "BulkDiscount", payload: [] });
          dispatch({ type: "BulkDiscountId", payload: [] });
          dispatch({ type: "VARIANT_COUNT", payload: 0 });

          dispatch({ type: "PRICE_LOG_FILTER_STATUS", payload: "success" });
          dispatch({ type: "PRICE_LOG_FILTER_STATUS_RESET", payload: "" });
        }
      })
      .catch((error) => {});
  };

  const getStorewideFilteredProducts = async () => {};

  const bufferRequest = async (
    {
      urls,
      method,
      data,
      keysToBuffer,
      lengthPerRequest = 2000,
      type = "SALE",
      shop,
    },
    callback = () => {}
  ) => {
    const lengthOfBufferKeys = {};
    let maxLength = -1;

    //GET LENGTH OF EACH KEY

    keysToBuffer.forEach((key) => {
      if (data[key] != undefined) {
        let length = data[key].length;
        if (maxLength == -1) {
          maxLength = length;
        }
        lengthOfBufferKeys[key] = length;
      }
    });

    //DIVIDE ALL THE BUFFER KEYS INTO CHUNKS
    let numberOfRequests = Math.ceil(maxLength / lengthPerRequest);
    if (numberOfRequests < 1) {
      authenticatedFetch({
        path: urls.mainRoute,
        method,
        body: JSON.stringify({
          data: { ...data, type, status: false, shop },
          shop,
        }),
        host,
        jwtToken,
        shop1,
      })
        .then((response) => response.json())
        .then((response) => {
          callback();
        })
        .catch(() => {
          callback();
        });
      return;
    }

    const size = lengthPerRequest;
    const bufferedData = {};
    Object.keys(lengthOfBufferKeys).forEach((key) => {
      for (let i = 0; i < data[key].length; i += size) {
        if (!bufferedData[key]) bufferedData[key] = [];
        bufferedData[key].push(data[key].slice(i, i + size));
      }
    });

    //MAKE HTTP REQUESTS

    let firstRequestResponse = null;
    for (let i = 0; i < numberOfRequests; i++) {
      let copyOfData = JSON.parse(JSON.stringify(data));
      try {
        Object.keys(bufferedData).forEach((key) => {
          if (bufferedData[key][i]) {
            copyOfData[key] = bufferedData[key][i];
          } else {
            copyOfData[key] = [];
          }
        });
        let response = {};
        if (i == 0) {
          let bufferStatus = true;
          if (i == numberOfRequests - 1) bufferStatus = false;
          console.log("Sending First Buffer Request", urls.mainRoute, {
            method: method,
            data: { ...copyOfData, type, status: bufferStatus, shop },
          });

          authenticatedFetch({
            path: urls.mainRoute,
            method,
            body: JSON.stringify({
              data: { ...copyOfData, type, status: bufferStatus, shop },
              shop,
            }),
            host,
            jwtToken,
            shop1,
          })
            .then((response) => response.json())
            .then((response) => {
              firstRequestResponse = response;
              callback();
            })
            .catch(() => {
              callback();
            });

        
        } else {
          if (i != numberOfRequests - 1) {
            console.log("Sending Buffer Request", urls.bufferRoute, {
              method: method,
              data: {
                ...copyOfData,
                ...firstRequestResponse,
                type,
                status: true,
                shop,
              },
            });

            response = await authenticatedFetch({
              path: urls.bufferRoute,
              method,
              body: JSON.stringify({
                data: {
                  ...copyOfData,
                  ...firstRequestResponse,
                  type,
                  status: true,
                  shop,
                },
                shop,
              }),
              host,
              jwtToken,
              shop1,
            });
          } else {
            console.log("Sending Last Buffer Request", urls.bufferRoute, {
              method: method,
              data: {
                ...copyOfData,
                ...firstRequestResponse,
                type,
                status: false,
                shop,
              },
            });
            response = await authenticatedFetch({
              path: urls.bufferRoute,
              method,
              body: JSON.stringify({
                data: {
                  ...copyOfData,
                  ...firstRequestResponse,
                  type,
                  status: false,
                  shop,
                },
                shop,
              }),
              host,
              jwtToken,
              shop1,
            });
          }
        }
      } catch (err) {
        //console.error("buffer function -> ", err);
        throw new Error("buffer function ->",err);
      }
    }
  };

  const saveBulkDiscount = async (data, callback) => {
    data.store = shop;
    data.createdBy = _id;
    const route = data.editMode
      ? `/api/updateBulkSale?shop=${shop}`
      : `/api/createBulkSale?shop=${shop}`;
    let payload = {
      urls: {
        mainRoute: route,
        bufferRoute: `/api/bufferData?shop=${shop}`,
      },
      keysToBuffer: ["productId"],
      data,
      type: "BULKSALE",
      method: "POST",
      shop,
    };
    if (data.productsAddedManually && !data.file_status) {
      if (data.excludedVariants.length < data.includedVariants.length) {
        data.productId = JSON.parse(JSON.stringify(data.excludedVariants));
        delete data.includedVariants;
        delete data.excludedVariants;
        data.includedStatus = false;
      } else {
        data.productId = JSON.parse(JSON.stringify(data.includedVariants));
        data.includedStatus = true;
        delete data.excludedVariants;
        delete data.includedVariants;
      }
    }
    await bufferRequest(payload, callback);
  };

  const saveCreateSaleRequest = async (data, callback) => {
    data.store = shop;
    data.createdBy = _id;
    let payload = {
      urls: {
        mainRoute: `/api/saveCreateSaleRequest?shop=${shop}`,
        bufferRoute: `/api/bufferData?shop=${shop}`,
      },
      keysToBuffer: ["productId"],
      data,
      type: "SALE",
      method: "POST",
      shop,
    };
    if (data.productsAddedManually && !data.file_status) {
      if (data.excludedVariants.length < data.includedVariants.length) {
        data.productId = JSON.parse(JSON.stringify(data.excludedVariants));
        delete data.includedVariants;
        delete data.excludedVariants;
        data.includedStatus = false;
      } else {
        data.productId = JSON.parse(JSON.stringify(data.includedVariants));
        data.includedStatus = true;
        delete data.excludedVariants;
        delete data.includedVariants;
      }
    }
    await bufferRequest(payload, callback);
  };

  const saveBulkSaleRequest = (data) => {
    data.store = shop;
    data.createdBy = _id;
    authenticatedFetch({
      path: `/api/saveBulkPriceChangeRequest?shop=${shop}`,
      method: "POST",
      body: JSON.stringify({ data, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong saveBulkPriceChangeRe");
        }
      })
      .then((res) => {
        dispatch({ type: `CREATE_SALE_LOG`, payload: data });
      })
      .catch((error) => {});
  };

  const editSaleRequest = async (data, callback) => {
    data.store = shop;
    data.createdBy = _id;
    let payload = {
      urls: {
        mainRoute: `/api/updateStoreSaleLog?shop=${shop}`,
        bufferRoute: `/api/bufferData?shop=${shop}`,
      },
      keysToBuffer: ["productId"],
      data,
      type: "SALE",
      method: "POST",
      shop,
    };
    if (data.productsAddedManually && !data.file_status) {
      if (data.excludedVariants.length < data.includedVariants.length) {
        data.productId = JSON.parse(JSON.stringify(data.excludedVariants));
        delete data.includedVariants;
        delete data.excludedVariants;
        data.includedStatus = false;
      } else {
        data.productId = JSON.parse(JSON.stringify(data.includedVariants));
        data.includedStatus = true;
        delete data.excludedVariants;
        delete data.includedVariants;
      }
    }
    await bufferRequest(payload, callback);
  };

  const getAllLogsFirstTime = () => {
    setLodingDiscountTrue();
    authenticatedFetch({
      path: `/api/getAllLogs/${shop1}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getAllLogs");
        }
      })
      .then((res) => {
        setAllLogStates(res);
        setLodingDiscountFalse();
      })
      .catch((error) => {});
  };

  const getAllLogs = (caller = "initial") => {
    authenticatedFetch({
      path: `/api/getAllLogs/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getAllLog");
        }
      })
      .then((res) => {
        if (res.allLogs == 0) {
          dispatch({
            type: `LIST_ALL_RULES_EMPTY`,
            payload: [],
          });
          return;
        }
        const statusArr = res.allLogs.map((item) => {
          return item.status;
        });
        if (res.allLogs !== 0 && caller == "initial") {
          setAllLogStates(res);
        } else if (caller == "iteration") {
          setAllLogStates(res);
          discountLogStatusArr = statusArr;
        } else if (caller == "force") {
          setAllLogStates(res);
          discountLogStatusArr = statusArr;
        }
      })
      .catch((error) => {});
  };

  function setAllLogStates(res) {
    if (res.allLogs == 0) {
      dispatch({
        type: `LIST_ALL_RULES`,
        payload: [],
      });
      return;
    }
    dispatch({
      type: `LIST_ALL_RULES`,
      payload: res.allLogs,
    });
    dispatch({ type: `LIST_ALL_START_DATE`, payload: res.start_date });
    dispatch({ type: `LIST_ALL_END_DATE`, payload: res.end_date });
  }

  const getSpecificSaleLog = async (id, callback = (err, data) => {}) => {
    authenticatedFetch({
      path: `/api/getSpecificSaleLog/${id}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getSpecificSaleLog");
        }
      })
      .then((res) => {
        callback(false, res);
      })
      .catch((error) => {
        callback(true);
      });
  };

  const getSaleLogsFirstTime = () => {
    setLodingBulkTrue();
    authenticatedFetch({
      path: `/api/getSaleLogs/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getSale");
        }
      })
      .then((res) => {
        setSalesLogStates(res);
        setLodingBulkFalse();
      })
      .catch((error) => {});
  };

  function setDiscountLogStates(res) {
    if (res == 0) {
      dispatch({
        type: `LIST_CREATE_BULK_DISCOUNT_RULES`,
        payload: [],
      });
      return;
    }
    dispatch({
      type: `LIST_CREATE_BULK_DISCOUNT_RULES`,
      payload: res,
    });
    dispatch({ type: `LIST_DISCOUNT_START_DATE`, payload: res });
    dispatch({ type: `LIST_DISCOUNT_END_DATE`, payload: res });
  }
  function setSalesLogStates(res) {
    if (res.bulk_price_responce == 0) {
      dispatch({
        type: `LIST_CREATE_SALE_RULES`,
        payload: [],
      });
      return;
    }
    dispatch({
      type: `LIST_CREATE_SALE_RULES`,
      payload: res.bulk_price_responce,
    });
    dispatch({ type: `LIST_BULK_START_DATE`, payload: res.start_date });
    dispatch({ type: `LIST_BULK_END_DATE`, payload: res.end_date });
  }

  const getBulkDiscountLogsFirstTime = () => {
    setLodingDiscountTrue();
    authenticatedFetch({
      path: `/api/getAllBulkSale/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getAllBulkSale");
        }
      })
      .then((res) => {
        setBulkDiscountLogStates(res);
        setLodingDiscountFalse();
      })
      .catch((error) => {});
  };

  const getDiscountLogs = (caller = "initial") => {
    authenticatedFetch({
      path: `/api/getAllBulkSale/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getAllBulkSale/");
        }
      })
      .then((res) => {
        if (res.bulk_price_responce == 0) {
          dispatch({
            type: `LIST_CREATE_BULK_DISCOUNT_RULES_EMPTY`,
            payload: [],
          });
          return;
        }

        const statusArr = res.bulk_price_responce.map((item) => {
          return item.status;
        });
        if (res.bulk_price_responce !== 0 && caller == "initial") {
          setBulkDiscountLogStates(res);
        } else if (caller == "iteration") {
          setBulkDiscountLogStates(res);
          discountLogStatusArr = statusArr;
        } else if (caller == "force") {
          setBulkDiscountLogStates(res);
          discountLogStatusArr = statusArr;
        }
      })

      .catch((error) => {});
  };

  function setBulkDiscountLogStates(res) {
    if (res.bulk_price_responce == 0) {
      dispatch({
        type: `LIST_CREATE_BULK_DISCOUNT_RULES`,
        payload: [],
      });
      return;
    }
    dispatch({
      type: `LIST_CREATE_BULK_DISCOUNT_RULES`,
      payload: res.bulk_price_responce,
    });
    dispatch({ type: `LIST_DISCOUNT_START_DATE`, payload: res.start_date });
    dispatch({ type: `LIST_DISCOUNT_END_DATE`, payload: res.end_date });
  }

  const getSaleLogs = (caller = "initial") => {
    authenticatedFetch({
      path: `/api/getSaleLogs/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong /api/getSaleLogs");
        }
      })
      .then((res) => {
        if (res.bulk_price_responce == 0) {
          dispatch({
            type: `LIST_CREATE_SALE_RULES_EMPTY`,
            payload: [],
          });
          return;
        }

        const statusArr = res.bulk_price_responce.map((item) => {
          return item.status;
        });
        if (res.bulk_price_responce !== 0 && caller == "initial") {
          setSalesLogStates(res);
        } else if (caller == "iteration") {
          setSalesLogStates(res);
          salesLogStatusArr = statusArr;
        } else if (caller == "force") {
          setSalesLogStates(res);
          salesLogStatusArr = statusArr;
        }
      })

      .catch((error) => {});
  };

  const dragDiscountLogModalSave = async (priorityList) => {
    authenticatedFetch({
      path: `/api/bulkSalePriorityChange?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ priorityList, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong bulkSalePriorityChange");
        }
      })
      .then((res) => {
        console.log("Response -> Discount Log -> Modal Save -> ", res);
        setDiscountLogStates(res.saleLogs);
      })
      .catch((error) => {});
  };

  const dragSaleLogModalSave = async (priorityList) => {
    authenticatedFetch({
      path: `/api/storeWideSalePriorityChange?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ priorityList, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong storeWideSalePriorityChange");
        }
      })
      .then((res) => {
        console.log("Response -> Sales Log -> Modal Save -> ", res);
        setSalesLogStates(res.saleLogs);
      })
      .catch((error) => {});
  };

  const cancelSaleLogs = async (metaFieldId) => {
    setLodingBulkTrue();
    setLodingDiscountTrue();
    authenticatedFetch({
      path: `/api/cancelSaleLogs/${metaFieldId}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong cancelSaleLogs");
        }
      })
      .then((res) => {
        getSaleLogs();
        setTimeout(() => {
          setLodingBulkFalse();
          setLodingDiscountFalse();
        }, 5000);
      })
      .catch((error) => {});
  };

  const cancelDiscountLogs = async (metaFieldId) => {
    setLodingDiscountTrue();
    authenticatedFetch({
      path: `/api/cancelDiscountLogs/${metaFieldId}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong i/cancelDiscountLogs");
        }
      })
      .then((res) => {
        getDiscountLogs();
        setTimeout(() => {
          setLodingDiscountFalse();
        }, 5000);
      })
      .catch((error) => {});
  };

  const getSalePriceCount = (caller = "initial") => {
    authenticatedFetch({
      path: `/api/getSalePriceCount/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong /api/getSalePriceCount");
        }
      })
      .then(({ storeMeteaFieldID }) => {
        if (caller == "initial") {
          dispatch({
            type: `UPDATED_PRODCUTS_REVERTING`,
            payload: storeMeteaFieldID,
          });
        } else if (
          caller == "iteration" &&
          storeMeteaFieldIDVal != storeMeteaFieldID
        ) {
          dispatch({
            type: `UPDATED_PRODCUTS_REVERTING`,
            payload: storeMeteaFieldID,
          });
          storeMeteaFieldIDVal = storeMeteaFieldID;
          setTimeout(() => {
            getSaleLogs("force");
          }, 5000);
        } else {
        }
      })
      .catch((error) => {});
  };

  const deleteSaleLog = (_id) => {
    setLodingBulkTrue();
    authenticatedFetch({
      path: `/api/deleteSaleLogs/${_id}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong /api/deleteSaleLogs");
        }
      })
      .then((res) => {
        getSaleLogs();
        setTimeout(() => {
          setLodingBulkFalse();
        }, 4000);
      })
      .catch((error) => {});
  };

  const deleteDiscountLog = (_id) => {
    setLodingDiscountTrue();
    authenticatedFetch({
      path: `/api/deleteDiscountLogs/${_id}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong i/deleteDiscount");
        }
      })
      .then((res) => {
        // dispatch({ type: `DELETE_SALE_LOG`, payload: discount_id });
        getDiscountLogs();
        setTimeout(() => {
          setLodingDiscountFalse();
        }, 4000);
      })
      .catch((error) => {});
  };

  const handleSalesLogToggle = (_id, index) => {
    setLodingBulkTrue();

    authenticatedFetch({
      path: `/api/toggleSaleLogs/${_id}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong toggleSaleLogs");
        }
      })
      .then((res) => {
        getSaleLogs();
        setTimeout(() => {
          setLodingBulkFalse();
        }, 4000);
      })
      .catch((error) => {});
  };

  const editCreateSaleRequest = (id, rulesObj) => {};

  /////////////////////////////////////////////////////
  const getStoreDateTime = async () => {
    try {
      let data = await authenticatedFetch({
        path: `/api/getStoreCurrentDateTime/${shop}?shop=${shop1}`,
        method: "get",
        host,
        jwtToken,
        shop1,
      });
      data = await data.json();

      const country_date_time = data.current_date_time.split(",");
      const country_date = country_date_time[0];
      const country_time_full = country_date_time[1];
      const country_time = country_time_full.slice(0, 5);
      return { country_date, country_time };
    } catch (err) {
      return { error: err };
    }
  };
  // Country Code Time Date
  const getStoreCurrentDateTime = () => {
    authenticatedFetch({
      path: `/api/getStoreCurrentDateTime/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getStoreCurrentDateTime");
        }
      })

      .then(
        ({
          country_code,
          current_date_time,
          totalStoreProducts,
          timeZone,
          currency,
        }) => {
          let zone = timeZone.split(" ")[1];
          zone=zone.replace("_", " ");
          const country_date_time = current_date_time.split(",");
          const country_date = country_date_time[0];
          const country_time_full = country_date_time[1];
          const country_time = country_time_full.slice(0, 5);
          const stateChange = {
            countryCode: zone,
            countryDate: country_date,
            countryTime: country_time,
            countryDateTime: current_date_time,
            countryCurrency: currency,
            totalStoreProducts: totalStoreProducts,
          };
          dispatch({ type: "SET_SALE_BULK_INFO", payload: stateChange });
        }
      )
      .catch((error) => {
        console.error(error);
        throw new Error("Get store date time",err);
      });
  };

  const clearFetchingStatus = () => {
    dispatch({ type: `PRODUCTS_FETCHING_STATUS`, payload: "" });
    dispatch({
      type: `PRODUCTS_FETCHING_STATUS_CURRENT_COUNT`,
      payload: 0,
    });
    dispatch({
      type: `PRODUCTS_FETCHING_STATUS_TOTAL_COUNT`,
      payload: 0,
    });
  };

  const navigateToUrl = (url) => {
    let element = document.createElement("a");
    if (url.startsWith("http://") || url.startsWith("https://")) {
      element.href = url;
    } else {
      element.href = "https://" + url;
    }
    element.target = "_blank";
    element.click();
  };
  // Products Fetch On App Install
  const getProductsFetchingStatus = (retries = 5) => {
    // let lastFetchCompleted = false;
    authenticatedFetch({
      path: `/api/getProductsFetchingStatus/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        if (retries > 0) {
        }
        throw new Error("getProductsFetchingStatus",res?.status);
      })
      .then(({ status, random_count }) => {
        if (status.current_status == "inprogress") {
          dispatch({ type: `PRODUCTS_FETCHING_STATUS`, payload: "inprogress" });
          dispatch({
            type: `PRODUCTS_FETCHING_STATUS_CURRENT_COUNT`,
            payload: random_count,
          });
          dispatch({
            type: `PRODUCTS_FETCHING_STATUS_TOTAL_COUNT`,
            payload: status.total_product,
          });
        } else if (status.current_status == "completed") {
          dispatch({ type: `PRODUCTS_FETCHING_STATUS`, payload: "completed" });
          dispatch({
            type: `PRODUCTS_FETCHING_STATUS_CURRENT_COUNT`,
            payload: status.current_product_count,
          });
          dispatch({
            type: `PRODUCTS_FETCHING_STATUS_TOTAL_COUNT`,
            payload: status.total_product,
          });
        } else if (status.current_status == "Failed") {
          navigateToUrl(`${origin}/auth?shop=${shop}`);
        }
      })
      .catch((err) => {
        console.log("Encountered Error While Fetching Product Status", err);
      });
  };

  //get Analytics Count
  const getAnalyticsCount = () => {
    authenticatedFetch({
      path: `/api/getDiscountsDetail?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong getDiscountsDetai");
        }
      })
      .then((res) => {
        dispatch({ type: `ANALYTICS_COUNT`, payload: res });
      })
      .catch((error) => {});
  };

  const CreateSaleUploadCsvFile = async (file, done = () => {}) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("shop", shop);

    await fetch("/api/cvsXlsxFileUploadStoreSale", {
      method: "post",
      body: formData,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong cvsXlsxFileUploadStoreSale");
        }
      })
      .then(
        ({
          final_array,
          file_name,
          filter_sku,
          preparedPayload,
          allProductsPricesFound,
        }) => {
          dispatch({ type: "BulkDiscount", payload: final_array });
          dispatch({ type: "BulkDiscountId", payload: preparedPayload });
          dispatch({ type: "VARIANT_COUNT", payload: preparedPayload.length });
          dispatch({ type: "UPLOADED_SKU", payload: filter_sku });

          let fileUploadProductLength = preparedPayload.length;

          dispatch({
            type: `FILE_UPLOAD_DATA`,
            payload: { fileUploadProductLength, file_name },
          });

          done({
            final_array,
            file_name,
            filter_sku,
            preparedPayload,
            allProductsPricesFound,
          });
        }
      )
      .catch((error) => {});
  };

  const clearFileUploadData = async () => {
    dispatch({
      type: `FILE_UPLOAD_DATA`,
      payload: null,
    });
  };

  const clearImpactedVariantsList = () => {
    dispatch({
      type: "SET_IMPACTED_VARIANTS",
      payload: { variants: [], impactedVariants: [] ,pagination:{},loading:false},
    });
  };

  const fetchImpactedVariants_SALES_LOG = async (data, logId, logType,pageSize,cursor,direction,searchKey="",type="successful") => {
    clearImpactedVariantsList();
    dispatch({
      type: "SET_IMPACTED_VARIANTS",
      payload: { variants: [], impactedVariants:[] , pagination:{},loading:true},
    });
    authenticatedFetch({
      path: `/api/StoreSaleViewModel?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({
        data: {
          shop: shop,
          variant_ids: data,
          logId,
          logType,
          pageSize,
          cursor,
          direction,
          searchKey,
          type
        },
      }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong StoreSaleViewModel");
        }
      })
      .then(({ final_array, impactedVariants,pagination }) => {
        dispatch({
          type: "SET_IMPACTED_VARIANTS",
          payload: { variants: final_array, impactedVariants , pagination,loading:false},
        });
      })
      .catch((error) => {
        dispatch({
          type: "SET_IMPACTED_VARIANTS",
          payload: { variants: [], impactedVariants: [] ,pagination:{},loading:false},
        });
      });
  };

  const BulkUploadCsvFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("shop", shop1);
    await fetch("/api/cvsXlsxFileUploadBulkPriceChange", {
      method: "post",
      body: formData,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong cvsXlsxFileUploadBulkPriceChange");
        }
      })
      .then(({ status, file_name, final_array, variants_array }) => {
        dispatch({ type: "BulkDiscount", payload: final_array });
        dispatch({ type: "BulkDiscountId", payload: variants_array });
        dispatch({ type: "VARIANT_COUNT", payload: variants_array.length });

        let fileUploadProductLength = variants_array.length;

        dispatch({
          type: `FILE_UPLOAD_DATA`,
          payload: { fileUploadProductLength, file_name },
        });
      })
      .catch((error) => {});
  };

  const storeFrontDesign = async (data, cb = (error, data) => {}) => {
    authenticatedFetch({
      path: `/api/storeFrontDesign?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ data, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong storeFrontDesign");
        }
      })
      .then((res) => {
        cb(false, res);
      })
      .catch((error) => {
        cb(true);
      });
  };

  const BulkTableDesign1 = async (data, cb = (error, data) => {}) => {

    authenticatedFetch({
      path: `/api/storeAppearance/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong pi/storeAppearance");
        }
      })
      .then(({ isAvailable, strikePrice }) => {
        //console.log("State Meta", data,strikePrice, strikePrice[0]?.design?.subscription, data?.design?.subscription);
        if (!isAvailable || strikePrice[0]?.design?.subscription!=data?.design?.subscription) {
          //console.log("hello");
          authenticatedFetch({
            path: `/api/storeAppearance?shop=${shop1}`,
            method: "POST",
            body: JSON.stringify({ data, shop }),
            host,
            jwtToken,
            shop1,
          })
            .then((res) => {
              if (res.ok) return res.json();
              else {
                throw new Error("Something went wrong storeAppearance1");
              }
            })
            .then((res) => {
              cb(false, res);
            })
            .catch((error) => {
              cb(true);
            });
        }
      })
      
  };

  const BulkTableDesign = async (data, cb = (error, data) => {}) => {
    console.log("Data", data);
    authenticatedFetch({
      path: `/api/storeAppearance?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ data, shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong storeAppearance");
        }
      })
      .then((res) => {
        cb(false, res);
      })
      .catch((error) => {
        cb(true);
      });
  };

  const getStoreFrontDesign = async () => {
    setLodingBulkTrue();
    authenticatedFetch({
      path: `/api/storeFrontDesign/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong i/storeFront");
        }
      })
      .then(({ isAvailable, strikePrice }) => {
        if (isAvailable) {
          let clockType = strikePrice[0].design.clockType;
          let clockPosition = strikePrice[0].design.clockPosition;
          let backgroundColor =
            strikePrice[0].design.clockStyle.backgroundColor;
          let borderColor = strikePrice[0].design.clockStyle.borderColor;
          let color = strikePrice[0].design.clockStyle.color;
          let fontSize = strikePrice[0].design.clockStyle.fontSize;
          let margin = strikePrice[0].design.clockStyle.margin;
          let padding = strikePrice[0].design.clockStyle.padding;
          let textAlign = strikePrice[0].design.clockStyle.textAlign;
          let clockToggle = strikePrice[0].design.clockToggle;
          let fontFamily = strikePrice[0].design.clockStyle.fontFamily;
          let fontWeight = strikePrice[0].design.clockStyle.fontWeight;

          dispatch({
            type: `SALE_CLOCK_DATA`,
            payload: {
              clockType,
              clockPosition,
              backgroundColor,
              borderColor,
              color,
              fontSize,
              margin,
              padding,
              textAlign,
              clockToggle,
              fontFamily,
              fontWeight,
            },
          });
        } else {
          dispatch({
            type: `SALE_CLOCK_DATA`,
            payload: {
              clockType: "0",
              clockPosition: "top_on_product_div",
              backgroundColor: "#FFFFFF",
              borderColor: "#000000",
              color: "#000000",
              fontSize: 16,
              margin: 0,
              padding: 20,
              textAlign: "center",
              fontFamily: "sans-serif",
              fontWeight: "200",
            },
          });
        }
        setLodingBulkFalse();
      })
      .catch((error) => {
        setLodingBulkFalse();
      });
  };

  const getBulkTableDesign = async () => {
    setLodingBulkTableTrue();
    authenticatedFetch({
      path: `/api/storeAppearance/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong pi/storeAppearance");
        }
      })
      .then(({ isAvailable, strikePrice }) => {
        if (isAvailable) {
          console.log("Strcysccs", strikePrice[0].design);
          let x=strikePrice[0].design;
          let BasicTextAlign = x.basicSettings.textAlign;
          let BasicFontFamily = x.basicSettings.fontFamily;
          let BasicFontSize = x.basicSettings.fontSize;
          let BasicFontWeight = x.basicSettings.fontWeight;
          let BasicMargin = x.basicSettings.margin;
          let BasicPadding = x.basicSettings.padding;
          let BasicBgColor = x.basicSettings.backgroudColor;
          let BasicFontColor = x.basicSettings.fontColor;
          let BasicBorderColor = x.basicSettings.borderColor;
          let BasicAlternateColor = x.basicSettings.alternativeRowBackgroundColor;

          let THTextAlign = x.TableHeading.textAlign;
          let THFontFamily = x.TableHeading.fontFamily;
          let THFontSize = x.TableHeading.fontSize;
          let THFontWeight = x.TableHeading.fontWeight;
          let THMargin = x.TableHeading.margin;
          let THPadding = x.TableHeading.padding;
          let THBgColor = x.TableHeading.backgroudColor;
          let THFontColor = x.TableHeading.fontColor;

          let TitleTextAlign = x.TableTitle.textAlign;
          let TitleFontFamily = x.TableTitle.fontFamily;
          let TitleFontSize = x.TableTitle.fontSize;
          let TitleFontWeight = x.TableTitle.fontWeight;
          let TitleMargin = x.TableTitle.margin;
          let TitlePadding = x.TableTitle.padding;
          let TitleText = x.TableTitle.text;
          let TitleFontColor = x.TableTitle.fontColor;

          let FooterTextAlign = x.FooterText.textAlign;
          let FooterFontFamily = x.FooterText.fontFamily;
          let FooterFontSize = x.FooterText.fontSize;
          let FooterFontWeight = x.FooterText.fontWeight;
          let FooterMargin = x.FooterText.margin;
          let FooterPadding = x.FooterText.padding;
          let FooterText = x.FooterText.text;
          let FooterFontColor = x.FooterText.fontColor;

          let clockToggle = x.clockToggle;


          dispatch({
            type: `BULK_TABLE_DATA`,
            payload: {
              BasicTextAlign,
              BasicFontFamily,
              BasicFontSize,
              BasicFontWeight,
              BasicMargin,
              BasicPadding,
              BasicBgColor,
              BasicFontColor,
              BasicBorderColor,
              BasicAlternateColor,
              THTextAlign,
              THFontFamily,
              THFontSize,
              THFontWeight,
              THMargin,
              THPadding,
              THBgColor,
              THFontColor,
              TitleTextAlign,
              TitleFontFamily,
              TitleFontSize,
              TitleFontWeight,
              TitleMargin,
              TitlePadding,
              TitleText,
              TitleFontColor,
              FooterTextAlign,
              FooterFontFamily,
              FooterFontSize,
              FooterFontWeight,
              FooterMargin,
              FooterPadding,
              FooterText,
              FooterFontColor,
              clockToggle
            },
          });
        } else {
          dispatch({
            type: `BULK_TABLE_DATA`,
            payload: {
              BasicTextAlign: "center",
              BasicFontFamily: "sans-serif",
              BasicFontSize: "11",
              BasicFontWeight: "Regular",
              BasicMargin: "10",
              BasicPadding: "16",
              BasicBgColor: "#EFEFEF",
              BasicFontColor: "#000000",
              BasicBorderColor: "#CED4DA",
              BasicAlternateColor: "#F6F6F6",
              THTextAlign: "center",
              THFontFamily: "sans-serif",
              THFontSize: "11",
              THFontWeight: "Regular",
              THMargin: "0",
              THPadding: "14",
              THBgColor: "#000000",
              THFontColor: "#FFFFFF",
              TitleTextAlign: "center",
              TitleFontFamily: "sans-serif",
              TitleFontSize: "11",
              TitleFontWeight: "Regular",
              TitleMargin: "0",
              TitlePadding: "14",
              TitleText: "Buy More, Save More!",
              TitleFontColor: "#000000",
              FooterTextAlign: "center",
              FooterFontFamily: "sans-serif",
              FooterFontSize: "11",
              FooterFontWeight: "Regular",
              FooterMargin: "0",
              FooterPadding: "14",
              FooterText: "See More",
              FooterFontColor: "#000000",
            },
          });
        }
        setLodingBulkTableFalse();
      })
      .catch((error) => {
        setLodingBulkTableFalse();
      });
  };

  const getTopbarAlert = async () => {
    authenticatedFetch({
      path: `/api/checking_product_sync_status/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong checking_product_sync_status");
        }
      })
      .then(({ status }) => {
        if (status != productSyncStatus) {
          dispatch({ type: "TOPBAR_ALERT_STATUS", payload: status });
          productSyncStatus = status;
        }
      })
      .catch((error) => {});
  };

  const syncSaleClock = async (callback) => {
    authenticatedFetch({
      path: `/api/syncSaleClock?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ store: shop }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong syncSaleClock");
        }
      })
      .then((res) => {
        callback(res);
      })
      .catch((error) => {
        callback(false, true);
      });
  };

  const getProductsBasedOnSKUS = async (data, file_name, saleId, callback) => {
    authenticatedFetch({
      path: `/api/editFileStoreSale?shop=${shop1}`,
      method: "POST",
      body: JSON.stringify({ skus: data, shop: shop, saleId }),
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else {
          throw new Error("Something went wrong editFileStoreSale");
        }
      })
      .then(
        ({
          final_array,
          status,
          filter_sku,
          preparedPayload,
          priceFromCSV,
          allProductsPricesFound,
        }) => {
          dispatch({ type: "BulkDiscount", payload: final_array });
          dispatch({ type: "BulkDiscountId", payload: preparedPayload });
          dispatch({ type: "UPLOADED_SKU", payload: filter_sku });
          const variantCount = () => {
            let count = 0;
            if (final_array && final_array.length > 0) {
              final_array.forEach((product) => {
                count += product.variants.length;
              });
            }
            return count;
          };
          let fileUploadProductLength = variantCount();
          dispatch({
            type: `FILE_UPLOAD_DATA`,
            payload: { fileUploadProductLength, file_name },
          });
          callback({
            titlePrice: final_array,
            filter_sku: filter_sku,
            fileUploadProductLength: fileUploadProductLength,
            file_name: file_name,
            priceFromCSV,
            allProductsPricesFound,
            preparedPayload,
          });
        }
      )
      .catch((error) => {
        console.log("Product Based on SKUS Returned Error", error);
      });
  };

  const setRevertingAlert = async (value) => {
    dispatch({ type: "TOPBAR_ALERT_STATUS", payload: value });
  };

  const clearUploadSKU = async () => {
    dispatch({ type: "UPLOADED_SKU", payload: [] });
  };

  const getEmbedStatus = async (callback = () => {}) => {
    authenticatedFetch({
      path: `/api/getStoreEmbeddedStatus/${shop}?shop=${shop1}`,
      method: "get",
      host,
      jwtToken,
      shop1,
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw new Error("Failed To Get Embed App Status");
      })
      .then((data) => {
        callback(false, data);
      })
      .catch((err) => {
        callback(true, err);
      });
  };

  return (
    <DiscountContext.Provider
      value={{
        saleLogToEdit: state.saleLogToEdit,
        bulkDiscountToEdit: state.bulkDiscountToEdit,
        variantsToReRunSaleOn: state.variantsToReRunSaleOn,
        variantsToReRunSaleOnWithProducts:
          state.variantsToReRunSaleOnWithProducts,
        message: state.message,
        discountRules: state.discountRules,
        singleDiscountRule: state.singleDiscountRule,
        loading: state.loading,
        saving: state.saving,
        loadingDiscounts: state.loadingDiscounts,
        toggleStatus: state.toggleStatus,
        shop: shop,
        bulkRules: state.bulkRules,
        loadingBulk: state.loadingBulk,
        loadingBulkTable: state.loadingBulkTable,
        loadingDiscount: state.loadingDiscount,
        titlePrice: state.titlePrice,
        impactedVariants: state.impactedVariants,
        BulkDiscountId: state.BulkDiscountId,
        discountRulesPriceChange: state.discountRulesPriceChange,
        ListBulkStartDate: state.ListBulkStartDate,
        ListBulkEndDate: state.ListBulkEndDate,
        ListDiscountStartDate: state.ListDiscountStartDate,
        ListDiscountEndDate: state.ListDiscountEndDate,
        countryCode: state.countryCode,
        countryDate: state.countryDate,
        countryTime: state.countryTime,
        hamburgerState: state.hamburgerState,
        countryCurrency: state.countryCurrency,
        totalUpdatedProducts: state.totalUpdatedProducts,
        totalUpdatedProductsReverting: state.totalUpdatedProductsReverting,
        variantCountArr: state.variantCountArr,
        totalStoreProductsCount: state.totalStoreProductsCount,
        productsFetchingStatus: state.productsFetchingStatus,
        productsFetchingStatusCurrentCount:
          state.productsFetchingStatusCurrentCount,
        productsFetchingStatusTotalCount:
          state.productsFetchingStatusTotalCount,
        analyticsCount: state.analyticsCount,
        priceLogFilterStatus: state.priceLogFilterStatus,
        gettingFilterStatusFromRes: state.gettingFilterStatusFromRes,
        fileUploadData: state.fileUploadData,
        discountRulesCreateSale: state.discountRulesCreateSale,
        bulkDiscountList: state.bulkDiscountList,
        allLogsList: state.allLogsList,
        ListCreateSaleStartDate: state.ListCreateSaleStartDate,
        ListCreateSaleEndDate: state.ListCreateSaleEndDate,
        salesClockData: state.salesClockData,
        bulkTableData: state.bulkTableData,
        mulipleBulkPriceChangeStatus: state.mulipleBulkPriceChangeStatus,
        toastStatus: state.toastStatus,
        topbarAlertStatus: state.topbarAlertStatus,
        queueStatus: state.queueStatus,
        uploadedSKU: state.uploadedSKU,
        filterLazyLoading: state.filterLazyLoading,
        logUnderObs: state.logUnderObs,
        subscriptionStatus: state.subscriptionStatus,
        error: state.error,
        totalAppliedRules: state.totalAppliedRules,
        //functions
        setVariantCount,
        clearImpactedVariantsList,
        fetchImpactedVariants_SALES_LOG,
        setSaleLogToEdit,
        setBulkDiscountToEdit,
        createStorewideSale,
        listDiscountRules,
        getSingleDiscountRule,
        changeMessage,
        deleteDiscountRule,
        toggleIsActive,
        setLodingTrue,
        setLodingFalse,
        setSavingTrue,
        setSavingFalse,
        updateDiscountRule,
        clearSingleDiscountRule,
        setLodingDiscountsTrue,
        setLodingDiscountsFalse,
        getTopbarAlert,
        createBulkOperation,
        saveBulkPriceChangeRequest,
        editBulkPriceChangeRequest,
        getBulkPriceChangeLog,
        cancelBulkPriceChangeLogs,
        getStoreCurrentDateTime,
        getUpdatedProducts,
        getBulkPriceChangeLogFirstTime,
        getAnalyticsCount,
        getProductsFetchingStatus,
        CreateSaleUploadCsvFile,
        BulkUploadCsvFile,
        createStorewideBulkOperation,
        saveCreateSaleRequest,
        saveBulkDiscount,
        saveBulkSaleRequest,
        editSaleRequest,
        getSaleLogsFirstTime,
        getBulkDiscountLogsFirstTime,
        getSaleLogs,
        getDiscountLogs,
        getSpecificSaleLog,
        dragSaleLogModalSave,
        dragDiscountLogModalSave,
        cancelSaleLogs,
        cancelDiscountLogs,
        getSalePriceCount,
        getStorewideFilteredProducts,
        deleteSaleLog,
        deleteDiscountLog,
        handleSalesLogToggle,
        editCreateSaleRequest,
        storeFrontDesign,
        getStoreFrontDesign,
        getBulkTableDesign,
        BulkTableDesign,
        BulkTableDesign1,
        clearProductFilteringList,
        productImpactedModalList,
        checkBulkPriceChangeRequestImpectedVariants,
        setRevertingAlert,
        reRunSale,
        setVariantsToReRunSaleOn,
        checkQueueStatus,
        clearUploadSKU,
        clearFileUploadData,
        getProductsBasedOnSKUS,
        getStoreDateTime,
        checkSaleLogEndDates,
        syncSaleClock,
        bufferRequest,
        setSubscribtionStatus,
        setTotalAppliedRules,
        switchToPro,
        handleAPIError,
        switchToFree,
        getSubscriptionStatus,
        clearFetchingStatus,
        getEmbedStatus,
        setHamburgetState,
        getAllLogs,
        getAllLogsFirstTime,
      }}
    >
      {props.children}
    </DiscountContext.Provider>
  );
};

export default DiscountState;
